/** @format */

import { IEnvironment } from '@shared/data-access/interfaces';
import { LoggerLevel } from '@shared/data-access/services';
import { PDP_CONSTANTS } from '../app/app.constants';
import { chain } from '@core/chain';
import killSwitchProd from './killswitch-prod';
import { prodEnvironmentDefaults } from '@shared/data-access/config';

const redirectingServiceBase = '/myaccount/services/redirectingservice';

export const environment: IEnvironment = {
	api: {
		endpoint: {
			product: `${chain.productAPIVersion}/store/${chain.storeId}/products/`,
			productNest: `${chain.nestjsProductAPIVersion}/store/${chain.storeId}/products/`
		},
		spring: {
			microService: {
				...prodEnvironmentDefaults.api.spring.microService,
				cart: 'https://www.dickssportinggoods.com/',
				logger: {
					AZ: 'https://active-loggerservice.iso.ap01.pcf.dcsg.com/',
					AZ2: 'https://active-loggerservice.iso.ap02.pcf.dcsg.com/',
					AZ3: 'https://active-loggerservice.iso.ap03.pcf.dcsg.com/',
					AKSEast: 'https://loggerservice.genextapps01.ue.p.aks.dcsg.com/',
					AKSWest: 'https://loggerservice.genextapps01.uw.p.aks.dcsg.com/'
				},
				product: {
					AZ: 'https://active-productservice.iso.ap01.pcf.dcsg.com/',
					AZ2: 'https://active-productservice.iso.ap02.pcf.dcsg.com/',
					AZ3: 'https://active-productservice.iso.ap03.pcf.dcsg.com/',
					AKSEast: 'https://active-productservice.iso.ap01.pcf.dcsg.com/',
					AKSWest: 'https://active-productservice.iso.ap03.pcf.dcsg.com/'
				}
			},
			microServiceProxy: {
				breadcrumb: {
					path: `/c/spring/msvc/breadcrumb/`,
					timeout: '5000'
				},
				cart: {
					path: `/api/v1/carts/contents`,
					timeout: '60000'
				},
				category: {
					path: `/c/spring/msvc/category/`,
					timeout: '30000'
				},
				logger: {
					path: `/${PDP_CONSTANTS.appPathPrefix}/spring/msvc/logger/`,
					timeout: '30000'
				},
				product: {
					path: `/${PDP_CONSTANTS.appPathPrefix}/spring/msvc/product/`,
					timeout: '60000'
				},
				promoservice: {
					path: `/${PDP_CONSTANTS.appPathPrefix}/spring/msvc/promo/`,
					timeout: '30000'
				},
				seoservice: {
					path: `/${PDP_CONSTANTS.appPathPrefix}/spring/msvc/seo/`,
					timeout: '30000'
				},
				recommendations: {
					path: '/api/spring/msvc/ds/v1/',
					timeout: '15000'
				}
			}
		},
		compare: `https://api-search.dickssportinggoods.com/catalog-productdetails/v4/store/${chain.storeId}/products/compare`,
		dataScience: {
			basePath: '/api/spring/msvc/ds/v1/',
			target: 'https://prod-ds-recs-details.iso.ap01.pcf.dcsg.com'
		},
		nestjs: {
			microService: {
				product: {
					AZ: 'https://active-productservice-nest.iso.ap01.pcf.dcsg.com/',
					AZ2: 'https://active-productservice-nest.iso.ap02.pcf.dcsg.com/',
					AZ3: 'https://active-productservice-nest.iso.ap03.pcf.dcsg.com/',
					AKSEast: 'https://active-productservice-nest.iso.ap01.pcf.dcsg.com/',
					AKSWest: 'https://active-productservice-nest.iso.ap03.pcf.dcsg.com/'
				}
			},
			microServiceProxy: {
				product: {
					path: `/${PDP_CONSTANTS.appPathPrefix}/nest/msvc/product/`,
					timeout: '15000'
				}
			}
		},
		nonmerch: {
			baseUrl: '/api/v1/nonmerch',
			timeout: '15000'
		},
		elastic: {
			inventory: 'https://availability.dickssportinggoods.com',
			availability: 'https://availability.dickssportinggoods.com',
			autoSuggestUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/',
			searchTermUrl: 'https://prod-catalog-product-api.dickssportinggoods.com/'
		},
		esb: {
			gatewayUrl: 'https://gateway.dcsg.com/',
			gatewayUrlProxy: {
				path: `/${PDP_CONSTANTS.appPathPrefix}/esb/api/`,
				timeout: '30000'
			},
			promotions: {
				apiKey: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
				env: 'prdlive',
				previewTime: '',
				channelId: '-1'
			}
		},
		homr: {
			previewLinks: true,
			proxy: {
				path: `/dcsg-ngx-home/homr/v2/api/`,
				timeout: '15000'
			},
			dapiV5: true,
			url: {
				AZ: 'https://main-dapi.iso.ap01.pcf.dcsg.com/',
				AZ2: 'https://main-dapi.iso.ap02.pcf.dcsg.com/',
				AZ3: 'https://main-dapi.iso.ap03.pcf.dcsg.com/',
				VS: 'https://main-dapi.iso.vp01.pcf.dcsg.com/',
				GCP: 'https://main-dapi.iso.gp01.pcf.dcsg.com/',
				AKSEast: 'https://main-dapi.iso.ap01.pcf.dcsg.com/',
				AKSWest: 'https://main-dapi.iso.ap03.pcf.dcsg.com/'
			},
			scene7Url: '//dks.scene7.com/is/image/dksfed/',
			scene7UrlCDN: '//dks.scene7.com/is/image/dkscdn/',
			scene7UrlContent: '//dks.scene7.com/is/content/dksfed/'
		},
		wscBaseUrl: 'https://www.dickssportinggoods.com/',
		brandify: {
			brandifyBaseUrl: 'https://hosted.where2getit.com/',
			proxy: {
				path: `/${PDP_CONSTANTS.appPathPrefix}/store/locator/`
			}
		},
		aem: {
			proxy: {
				path: `/content/experience-fragments/dsg/us/en/site/size_charts/`
			}
		},
		tickerUrl: 'https://fdhmfhecfi.execute-api.us-east-1.amazonaws.com/prod/',
		inStockReminder: {
			baseUrl: 'https://www.dickssportinggoods.com/'
		},
		ceops: prodEnvironmentDefaults.api.ceops,
		reactMarginals: prodEnvironmentDefaults.api.reactMarginals,
		kraken: prodEnvironmentDefaults.api.kraken,
		promoteIQ: 'https://ad-dickssportinggoods-prod.tagdelivery.com/request?',
		criteo: {
			baseUrl: 'https://d.us.criteo.com/delivery/retailmedia?',
			nolog: 0,
			partnerId: {
				dsg: 25953,
				gg: 35855
			}
		},
		myaccount: {
			basePath: '/myaccount/services/',
			partnerKey: 'pdp_ui',
			secretKey: '2dNuP6rTcVlbZm3wMBYj'
		},
		seo: 'https://api-search.dickssportinggoods.com/',
		seoByChain: `https://api-search.${chain.seoIdentifier}.com/`,
		edd: {
			baseUrl: 'https://edd-prod.dcsg.com/',
			proxy: {
				path: `/${PDP_CONSTANTS.appPathPrefix}/api/spring/msvc/`,
				timeout: '15000'
			}
		},
		sdd: {
			baseUrl: 'https://availability.dickssportinggoods.com/',
			proxy: {
				path: `/${PDP_CONSTANTS.appPathPrefix}/v1/same-day-availability/zipcode/sku`,
				timeout: '15000'
			}
		},
		productList: 'https://prod-catalog-product-api.dickssportinggoods.com/',
		mlEvents: 'https://api-search.dickssportinggoods.com/ml/v1/events',
		myLocker: '/v1/mylocker'
	},
	apiTokens: {
		brandify: {
			storeLocator: {
				dsg: '8D669860-73FB-11E8-8752-FF2F0D70A832',
				gg: 'CE23B360-C828-11E4-B146-ED9AA38844B8'
			}
		},
		esb: {
			api: '38d00cb0-6e1b-11e6-8390-8c24708cfd68',
			api2: '9b59c9e0-6710-11e7-bdcc-80098dffd0fa',
			data: '1bfc85f0-ea22-11e5-9697-8d6fc3625af1',
			identity: 'af727360-d115-11e5-ab08-be8d24eccbe9',
			myaccount: 'd0b85d50-d115-11e5-ab08-b8fc4c91c2b3',
			inventory: '1e370cd0-90fd-11e8-88c8-b1d2f2dd8b93'
		},
		contentAPI: {
			key: 'VDJSNWMzTmxlVkJ5YjJRPSBsQ2Y+T35pMGhiKnRea2ZGKCtJR1slRWldfUlRYys='
		},
		inStockReminder: {
			key: 'lYbOzWsmoT68bF1D3JD6',
			partner: 'Excomm'
		},
		elastic: {
			availability: 'pdp-90c1c1ae-1580-11ec-a613-4f5255dd8e74'
		}
	},
	catOvrGrpId: {
		calia: '3074457345618270104',
		dsg: '3074457345618270104',
		gg: '10501'
	},
	customizer: 'https://dsg-responsive-v2.mycustomizer.com',
	dataFiles: {
		csv: {
			proxy: {
				path: `/${PDP_CONSTANTS.appPathPrefix}/assets/csv/`,
				timeout: '30000'
			}
		},
		json: {
			proxy: {
				path: `/${PDP_CONSTANTS.appPathPrefix}/assets/json/`,
				timeout: '30000'
			}
		}
	},
	defaultActiveCloudProvider: 'AZ',
	esbEnvironmentHeader: 'auxlive',
	inventory: {
		locationId: 0
	},
	apiAuthKeys: {
		partnerKey: 'pdp_ui',
		secretKey: '2dNuP6rTcVlbZm3wMBYj'
	},
	logging: {
		client: {
			level: LoggerLevel.LOG
		},
		xhr: {
			level: LoggerLevel.LOG, // DO NOT TOUCH
			url: 'https://prod-log-publisher.iso.gp01.pcf.dcsg.com/publish'
		}
	},
	myAccount: {
		authServiceBaseUrl: 'https://myaccount.dickssportinggoods.com/prod/authservice'
	},
	loyalty: {
		scorecard: 'https://myaccount-loyalitypointsservice.iso.ap01.pcf.dcsg.com/'
	},
	pricing: {
		path: '/discount/details/',
		env: 'https://dcsg-prod.api.dickssportinggoods.com/',
		esbEnvironmentHeader: 'prdlive'
	},
	production: true,
	searchbyTermTypeParam: '1000',
	thirdParty: {
		auth0: {
			...prodEnvironmentDefaults.thirdParty.auth0
		},
		honeycomb: {
			apiKey: process.env.HONEYCOMB_PROD_API_KEY,
			serviceName: 'frontend-ui-p'
		},
		images: {
			...prodEnvironmentDefaults.images,
			flags: {
				useProxy: false,
				useNetstorage: false
			}
		},
		scene7: {
			baseConfig: {
				baseUrl: 'https://dks.scene7.com/',
				cdn: 'GolfGalaxy/',
				css: 'skins/Scene7SharedAssets/htmlviewerskins/css/html5_mixedmediaviewer_light.css',
				imageDirectory: 'is/image/',
				queryString: '?req=set,json,UTF-8',
				sdkUrl: 's7sdk/3.3/js/s7sdk',
				secureBaseUrl: 'https://dks.scene7.com/',
				videoDirectory: 'is/content/',
				viewerUrl: 's7viewers/html5/js/MixedMediaViewer.js',
				closedCaption: 'is/content/GolfGalaxy/MasterCatalog/Videos/'
			},
			url: 'https://dks.scene7.com/is/image/dkscdn/',
			suffix: '$DSG_ProductCard$',
			timeout: 100000
		},
		bv: {
			store: {
				dsg: {
					script: 'https://apps.bazaarvoice.com/deployments/dsg/main_site/production/en_US/bv.js',
					userToken: 'dsg-be3689187c297c52e22c973ac8bfcaaa'
				},
				gg: {
					script: 'https://apps.bazaarvoice.com/deployments/golfgalaxy/main_site/production/en_US/bv.js',
					userToken: 'golfgalaxy-78f5ef807b53fc6fcc0a3f143f3b2a13'
				},
				pl: {
					script: 'https://apps.bazaarvoice.com/deployments/publiclands/main_site/production/en_US/bv.js',
					userToken: ''
				},
				g3: {
					script: 'https://apps.bazaarvoice.com/deployments/goinggoing/main_site/production/en_US/bv.js',
					userToken: ''
				},
				dsgQA: {
					script: 'https://apps.bazaarvoice.com/deployments/dsg/qna_enabled_categories/production/en_US/bv.js',
					userToken: 'dsg-be3689187c297c52e22c973ac8bfcaaa'
				},
				ggQA: {
					script: '',
					userToken: ''
				},
				plQA: {
					script: '',
					userToken: ''
				}
			},
			api: {
				fullUrl:
					'https://api.bazaarvoice.com/data/products.json?ApiVersion=5.4&Passkey=pviax3zxu03mx4vto1clhr0mo&stats=Reviews&filter=id:eq:',
				baseUrl: 'https://api.bazaarvoice.com/data/',
				proxyConfig: {
					baseUrl: 'https://api.bazaarvoice.com/',
					proxy: {
						path: `/${PDP_CONSTANTS.appPathPrefix}/reviews-api/`,
						timeout: '10000'
					}
				},
				contentType: 'products.json',
				version: '?ApiVersion=5.4',
				filters: '&stats=Reviews&filter=id:eq:',
				questionUrl:
					'https://api.bazaarvoice.com/data/products.json?ApiVersion=5.4&Passkey=pviax3zxu03mx4vto1clhr0mo&stats=Questions&filter=id:eq:',
				reviewSummaryUrl: 'https://api.bazaarvoice.com/data/reviews.json',
				reviewsUrl: 'data/reviews.json',
				statisticsUrl: 'data/statistics.json',
				feedbackUrl: 'data/submitfeedback.json',
				reviewAISummaryUrl: 'data/reviewsummary',
				summarisedFeaturesUrl: 'sentiment/v1/summarised-features',
				baseDomain: {
					dsg: 'https://www.dickssportinggoods.com',
					gg: 'https://www.golfgalaxy.com',
					pl: 'https://www.publiclands.com',
					g3: 'https://www.goinggoinggone.com'
				},
				revewSummaryApiVersion: '5.4',
				dsg: {
					apiPassKey: 'ca0xQmHX4WgFjkpXBiYS8IElwqm2IYIG1RIYQ2LLTnLKA',
					reviewSummaryPassKey: 'cahWEzSiPp0IPkqzl0gm4jqVhsyCj0T2DLPYonOqIqDoc',
					sentimentsApiAuthHeaderKey: '9rajFNgRoaTHNHgCU5HdMOhTBBKmOte2g5jRXtpQZXI'
				},
				gg: {
					apiPassKey: 'pviax3zxu03mx4vto1clhr0mo',
					reviewSummaryPassKey: 'pviax3zxu03mx4vto1clhr0mo',
					sentimentsApiAuthHeaderKey: '9rajFNgRoaTHNHgCU5HdMOhTBBKmOte2g5jRXtpQZXI'
				},
				pl: {
					apiPassKey: '',
					reviewSummaryPassKey: 'caFjnjvVszzySdBBx1EGT9OwwpD7WHYXhJQbrvqqxKTSo',
					sentimentsApiAuthHeaderKey: '9rajFNgRoaTHNHgCU5HdMOhTBBKmOte2g5jRXtpQZXI'
				},
				g3: {
					apiPassKey: '',
					reviewSummaryPassKey: 'caxefIVBDAKGmg08pu3Z3gYntXkPnYFr0OsF2TDROixDU',
					sentimentsApiAuthHeaderKey: ''
				}
			},
			socialApi: {
				fullUrl: 'https://edge.curalate.com/v1/media/',
				dataSourceIdReveal: 'OBrqpNqExauCoVzf',
				brandDomains: {
					dsg: 'https://www.dickssportinggoods.com'
				},
				proxyConfig: {
					baseUrl: 'https://edge.curalate.com/v1/media/',
					proxy: {
						path: `/${PDP_CONSTANTS.appPathPrefix}/social-api/`,
						timeout: '15000'
					}
				}
			}
		},
		searchDex: {
			gatewayUrlProxy: {
				path: `/${PDP_CONSTANTS.appPathPrefix}/sdxincludes/api/`,
				timeout: '15000'
			},
			store: {
				calia: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				dsg: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				gg: {
					baseUrl: 'https://www.golfgalaxy.com/products/includes/'
				},
				pl: {
					baseUrl: 'https://www.publiclands.com/products/includes/'
				},
				g3: {
					baseUrl: 'https://www.goinggoing.com/products/includes/'
				}
			}
		},
		tealium: {
			enabled: true,
			store: {
				dsg: {
					baseUrl: 'https://tag.dickssportinggoods.com/utag.js'
				},
				gg: {
					baseUrl: 'https://tag.golfgalaxy.com/utag.js'
				},
				pl: {
					baseUrl: 'https://tag.publiclands.com/utag.js'
				},
				g3: {
					baseUrl: 'https://tag.goinggoinggone.com/utag.js'
				}
			}
		},
		trueFit: {
			baseUrl: 'assets/plugins/truefit/js/truefit.prod.min.js'
		},
		i3: {
			store: {
				calia: {
					enabled: false,
					baseUrl: 'assets/plugins/i3/86.bundle.min.js'
				},
				dsg: {
					enabled: false,
					baseUrl: 'assets/plugins/i3/86.bundle.min.js'
				},
				gg: {
					enabled: false,
					baseUrl: 'assets/plugins/i3/86.bundle.min.js'
				}
			}
		},
		paypal: {
			store: {
				dsg: {
					baseUrl: 'https://www.paypal.com/sdk/js',
					clientIdParam:
						'?client-id=Afzx1xURRoQqg7bEsKTa4bYcGFJptBY-kkesPYm0SquRn6IVWPw9M_W6TLl9MWU7hCzAEn9mt8vRzGKz',
					additionalParams: '&components=messages'
				},
				gg: {},
				pl: {},
				g3: {}
			}
		},
		affirm: {
			store: {
				dsg: {
					script: 'assets/plugins/affirm/affirm.prod.js'
				},
				gg: {},
				pl: {},
				g3: {}
			}
		},
		bnpl: {
			baseUrl: 'https://payments.dickssportinggoods.com/library/ads/assets-manifest.json',
			scriptSrc: 'https://payments.dickssportinggoods.com/library/ads/index-v1.js'
		},
		stylitics: {
			store: {
				dsg: {
					script: 'https://widget.stylitics.com/v2/widget.js'
				},
				gg: {},
				pl: {
					script: 'https://widget.stylitics.com/v2/widget.js'
				},
				g3: {}
			}
		}
	},
	feature: {
		...prodEnvironmentDefaults.feature
	},
	killSwitch: { ...killSwitchProd },
	launchConfig: {},
	baseDomain: {
		...prodEnvironmentDefaults.baseDomain
	},
	identityServiceKey: {
		partnerKey: 'pdp_ui',
		secretKey: '2dNuP6rTcVlbZm3wMBYj'
	},
	partyAuthKeys: {
		partnerKey: 'tof',
		secretKey: 'DYBZfgOIt2liWVYrPiPw'
	},
	baseUrls: {
		addressService: `${redirectingServiceBase}/addressservice`,
		athleteService: `${redirectingServiceBase}/athleteservice`,
		authService: `${redirectingServiceBase}/authservice`,
		automatedToolingService: `${redirectingServiceBase}/automatedtoolingservice`,
		logonService: `${redirectingServiceBase}/logonservice`,
		orderService: `${redirectingServiceBase}/orderservice`,
		pointService: `${redirectingServiceBase}/pointservice`,
		segmentationService: `${redirectingServiceBase}/segmentationservice`,
		textSubscriptionService: `https://externalcomm-textsubscriptionservice.dcsg.com`,
		consumerApi: `${redirectingServiceBase}/consumerapi`,
		identityService: '/athleterecord/services/redirectingservice/identityservice',
		emailValidationService: `${redirectingServiceBase}/emailvalidationservice`
	},
	platform: {
		forwardedHeadersMatchers: [/v4\/byURL/, /\/v1\/categories/, /availability\./, /\/homr\//]
	}
};
